import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sleep",
  "description": "",
  "published": "2006-07-12T00:00:00.000Z",
  "redirect_from": ["/blog/sleep/swizec/398"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sleep simply sucks. Yes the body needs it and apparently so does the mind, that's what official mainstream science says anyway.`}</p>
    <p>{`But you can rest assured that as soon as you get more than what you are accustomed to there are problems. Not only is the day magically shortened and you are unable to complete all of your duties it also leaves you sleepy, cranky and otherwise in a bad mood.`}</p>
    <p>{`This is even better topped off if on the same day a lot of things seem to go wrong, like raining the moment you want to bike to work and then ahving to wait a whole whole lot of time waiting for the bus plus when coming back to the bike... it's stolen.`}</p>
    <p>{`All in all... sleep is bad for you.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      